import React, { useState, useEffect } from 'react'
import './AllProjectsCardItem.scss'
import PropTypes from 'prop-types'
import { Card, CardContent } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment'
import { getCurrentLocaleDate } from '@engine/utils/format'
import IconButton from '@material-ui/core/IconButton'
import FavoriteIcon from '@material-ui/icons/Favorite'
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder'
import MoreVertIcon from '@material-ui/icons/MoreVert'
// import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Fade from '@material-ui/core/Fade'

const useStyles = makeStyles(theme => ({
  root: {
    minWidth: 252,
    background: '#FFFFFF',
    borderRadius: 1,
    color: '#5E6C84',
    '&:hover': {
      boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.17)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      })
    }
  },
  editIcons: {
    color: '#5E6C84'
  }
}))

const AllProjectsCardItem = props => {
  const { projectData, userId, deleteProject, onSelectFavorite } = props
  const [anchorEl, setAnchorEl] = useState(false)
  const [selectFavorite, deselectFavorite] = useState(projectData.isFavorited)
  const classes = useStyles()

  const handleClick = event => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }
  const handleClose = evt => {
    evt.stopPropagation()
    setAnchorEl(null)
  }

  useEffect(() => {
    if (selectFavorite !== projectData.isFavorited) {
      deselectFavorite(projectData.isFavorited)
    }
  }, [projectData.isFavorited])

  const deleteActionHandler = e => {
    e.stopPropagation()
    setAnchorEl(null)
    deleteProject({ 'isDeleted': true, selectedProjectId: projectData.id, projectName: projectData.projectName.split('.')[0] })
  }

  const handleFavoriteAction = (event, ...favoriteObj) => {
    event.stopPropagation()
    deselectFavorite(!selectFavorite)
    onSelectFavorite({ favorite: favoriteObj[0], userId: favoriteObj[1], projectId: favoriteObj[2] })
  }

  // if (!projectData.signedUrl) {
  //   projectData.signedUrl = '/images/no_photo.svg'
  // }

  return (
    <Fade in={true} timeout={500}>
      <div className={projectData.isDeleted ? 'project-card-disabled' : 'project-card'} style={{ opacity: projectData.isDeleted ? 0.6 : 1 }} >
        <Card className={classes.root} variant="outlined" data-testid="all-project-card-content" onClick={props.onClick}>
          <CardContent className="cardContentAllProjects">
            <div>
              <img className="propertyImageIcon" src={projectData.signedUrl ? projectData.signedUrl : '/images/no_photo.svg'} width="48px" height="48px" />
            </div>
            <div className="propertyDetails">
              <div className="cardElipsis">
                <span className="boldTextName">{projectData.projectName.split('.')[0]}</span>
                <br />
                <span className="grayTextColor">{projectData.city}</span>
              </div>
            </div>
            <div>
              <span className="boldText">{projectData.dealNumber}</span>
              <br />
              <span className="grayTextColor">Deal ID</span>
            </div>
            <div>
              <span className="boldText" id="owner-cell">{projectData.created_user_name}</span>
              <br />
              <span className="grayTextColor">Owner</span>
            </div>
            <div>
              <span className="boldText">{moment(getCurrentLocaleDate(projectData.modifiedDate)).format('ll')}</span>
              <br />
              <span className="grayTextColor">Last Modified</span>
            </div>
            <div className="listSeperator">
              <IconButton data-testid={`favorite-icon-${projectData.id}`} onClick={e => handleFavoriteAction(e, false, userId, projectData.id)}>
                {selectFavorite && (
                  <FavoriteIcon className={classes.editIcons} />
                )}
              </IconButton>
              <IconButton data-testid={`unfavorite-icon-${projectData.id}`} onClick={e => handleFavoriteAction(e, true, userId, projectData.id)}>
                {!selectFavorite && (
                  <FavoriteBorderIcon className={classes.editIcons} />
                )}
              </IconButton>
            </div>
            <div className="">
              <IconButton data-testid="edit-card-menu" onClick={handleClick}>
                <MoreVertIcon />
              </IconButton>
            </div>
          </CardContent>
        </Card>
        {
          anchorEl &&
          <Menu id="card-menu" anchorEl={anchorEl} keepMounted data-testid="all-projects-card-menu" open={Boolean(anchorEl)} onClose={handleClose}>
            {/* <MenuItem onClick={handleClose}>
                  <EditIcon className={classes.editIcons} />
                  <span className="menu-item" data-testid="rename">Rename</span>
                </MenuItem> */}
            <MenuItem disabled={(userId !== projectData.createdUserGuid)} onClick={e => deleteActionHandler(e)}>
              <DeleteIcon className={classes.editIcons} />
              <span className="menu-item" data-testid="delete">Delete</span>
            </MenuItem>
          </Menu>
        }
      </div>
    </Fade>
  )
}

AllProjectsCardItem.propTypes = {
  projectData: PropTypes.object,
  onClick: PropTypes.func,
  userId: PropTypes.string,
  deleteProject: PropTypes.func,
  onSelectFavorite: PropTypes.func
}

export default AllProjectsCardItem
